import React from 'react';
import { FormattedMessage } from 'react-intl';
import Switch from "react-switch";
// import ReactDataGrid from 'react-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Tabs from 'react-responsive-tabs';
import 'react-responsive-tabs/styles.css';
import { withTranslation } from "react-multi-lang";
import { withAlert } from "react-alert";
import {
    getNestedFieldData, getTabs//, isDate, getTimeZoneFormattedDate
} from '../components/CommonScript';

 class Label extends React.Component {
    render() {
        return (
            <label>
                {/* {<FormattedMessage id={this.props.multiLingualId}
                    defaultMessage={this.props.multiLingualMsg}>
                </FormattedMessage>} {' '} */}
                {this.props.t(this.props.multiLingualId)}

                {this.props.required === true ? <span className="text-danger font-weight-bold"> *</span> : ''}
            </label>
        )
    }
}

export default withAlert()(withTranslation(Label));



export class Button extends React.Component {
    render() {
        return (
            <button
                name={this.props.name}
                ref={this.props.refName}
                className={this.props.class}
                type={this.props.type || 'button'}
                hidden={this.props.hidden || ''}
                onClick={this.props.onClick}
                disabled={this.props.disabled}
            ><strong>
                    {<FormattedMessage id={this.props.multiLingualId}
                        defaultMessage={this.props.multiLingualMsg}>
                    </FormattedMessage>} {' '}
                </strong>
            </button>
        )
    }
}

export class Input extends React.Component {

    render() {
        return (
            <FormattedMessage id={this.props.multiLingualId}
                defaultMessage={this.props.multiLingualMsg}>
                {Label =>
                    <input
                        className={this.props.class}
                        id={this.props.id}
                         style={this.props.style}
                        ref={this.props.refName}
                        type={this.props.type}
                        name={this.props.name}
                        placeholder={Label}
                        required={this.props.required}
                        onBlur={this.props.onBlur}
                        onKeyUp={this.props.onKeyUpHandler}
                        hidden={this.props.hidden}
                        onChange={this.props.onChangeEventHandler}
                        onClick={this.props.onClickEventHandler}
                        maxLength={this.props.maxLength}
                        max={this.props.max}
                        min={this.props.min}
                        defaultValue={this.props.defaultValue}
                        readOnly={this.props.readOnly}
                        accept={this.props.accept}
                        data-max-size={this.props.dataMaxSize}
                        value={this.props.value}
                        checked={this.props.checked}
                        autoComplete="off"
                    />}</FormattedMessage>
        )
    }
}

 export class Select extends React.Component {
    render() {
        return (
            <FormattedMessage id={this.props.multiLingualId}
                defaultMessage={this.props.multiLingualMsg}>
                {Label =>
                    <select
                        className={this.props.class}
                        style={this.props.style}
                        name={this.props.name}
                        ref={this.props.refName}
                        onChange={this.props.onChange}
                        required={this.props.required}
                        defaultValue={this.props.defaultValue}
                        value={this.props.value}
                        disabled={this.props.disabled}
                    >
                        {this.props.showOption ?
                            <option value={''}>
                                {' '}-- {Label} --{' '}
                            </option> : ''}

                        {this.props.options.map(option => (
                            typeof (option) === "object"
                                ? (
                                    typeof (this.props.optionText) === "object" ?
                                        (    <option value={option[this.props.optionValue]} key={option[this.props.optionId]} >
                                                {getNestedFieldData(this.props.optionText["0"], option)}
                                            </option>
                                        ) :
                                        (    <option value={option[this.props.optionValue]} key={option[this.props.optionId]} >
                                                {option[this.props.optionText]}
                                            </option>)
                                ) : (
                                    <option value={option} key={option}>
                                        {option}
                                    </option>
                                )
                        ))}

                    </select>
                }
            </FormattedMessage>
        )
    }
}

export class TextArea extends React.Component {

    render() {
        return (
            <FormattedMessage id={this.props.multiLingualId}
                defaultMessage={this.props.multiLingualMsg}>
                {Label =>
                    <textarea
                        className={this.props.class}
                        style={this.props.style}
                        ref={this.props.refName}
                        type={this.props.type}
                        name={this.props.name}
                        maxLength={this.props.maxLength}
                        placeholder={Label}
                        required={this.props.required}
                        onBlur={this.props.onBlur}
                        rows={this.props.rows}
                        readOnly={this.props.readOnly}
                        value={this.props.value}
                        onSelect={this.props.onSelect}
                        onChange={this.props.onChangeEventHandler}
                    ></textarea>}</FormattedMessage>
        )
    }
}

export class CheckBox extends React.Component {
    render() {
        return (
            <input
                type="checkbox"
                key={this.props.keyName}
                name={this.props.name}
                className={this.props.class}
                onChange={this.props.onChange}
                readOnly={this.props.readOnly}
                checked={this.props.checked}
                disabled={this.props.disabled}
                hidden={this.props.hidden}
                value={this.props.value} />
        )
    }
}

export const FlipButton = props => {
    return (
        <Switch id={props.buttonId}
            onChange={props.handleOnChange}
            checked={props.isChecked}
            disabled={props.buttonDisabled}
            height={props.buttonHeight}
            width={props.buttonWidth}
            ref={props.refName} />
    );
}

export const Grid = (props) => {
    return (
        // <ReactDataGrid
        // columns={props.columns}
        // rowGetter={props.rowGetter}
        // rowsCount={props.rows.length}
        // minHeight={200}
        // enableCellSelect={false}/>
        <div></div>)
}

export class DatePickerControl extends React.Component {
    render() {
        return (
            <DatePicker
                id={this.props.id}
                name={this.props.name}
                ref={this.props.refName}
                selected={this.props.selected}
                onSelect={this.props.handleDateSelect} //when day is clicked
                onChange={this.props.handleDateChange} //only when value has changed
                dateFormat="dd/MM/yyyy"
                className={this.props.className}
            />
        )
    }
}

export const DisplayGridData = (props) => {
    let tabArray = [];
    let gridData = props.data;

    Object.keys(props.data).map(tabName => {
        return tabArray.push(tabName)
    });

    let tabObject = [];
    tabArray.map(tabName => {
        let rowObject = {};
        rowObject["name"] = tabName;

        let columns = [];
        let rows = [];
        let rowGetter = rowNumber => rows[rowNumber];

        gridData[tabName].map((fieldData, index) => {
            let rowObject = {};
            Object.keys(fieldData).map(fieldName => {
                if (index === 0) {
                    columns.push({
                        "key": fieldName,
                        "name": <FormattedMessage id={fieldName} defaultMessage={fieldName} />,
                        frozen: false,
                        resizable: true,
                        editable: false
                    });
                }
                if (typeof (fieldData[fieldName]) === "object") {
                    return rowObject[fieldName] = getNestedFieldData(props.objectField[fieldName], fieldData)
                }
                else {
                    // return rowObject[fieldName] = isDate(fieldData[fieldName]) === true ?                            
                    //             (getTimeZoneFormattedDate(fieldData[fieldName], 'Asia/Calcutta'))                                  
                    //             : fieldData[fieldName]                
                    return rowObject[fieldName] = fieldData[fieldName];
                }
            })

            return rows.push(rowObject);

        })
        rowObject["content"] = <Grid columns={columns} rows={rows} rowGetter={rowGetter} />;
        return tabObject.push(rowObject);
    })

    return (
        <Tabs items={getTabs(tabObject)} showInkBar={true} />
    );

}

